import { ThemeProvider } from "@material-ui/core";
import { Dashboard, Feedback, Home, Login, NotFound, Request } from "@screens";
import { getSession, State } from "@store";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import { Content } from "./content";
import { Footer } from "./footer";
import { Header } from "./header";
import { theme } from "./theme";
import { Wrapper } from "./wrapper";
import { Modals } from "./modals";
import { ReleaseNotes } from "../screens/release-notes";
import { Announcements } from "../screens/announcements";
import { GEARS_TOKEN } from "@constants";
import { store } from "@store";

const PrivateRoute = ({ children, ...rest }: any) => {
  const user = useSelector((state: State) => state.user);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        user ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: {
                from: location,
              },
            }}
          />
        )
      }
    />
  );
};

export const App: React.FC = () => {
  const dispatch = useDispatch();
  const gearsToken = sessionStorage.getItem(GEARS_TOKEN);
  const { user } = store.getState();
  //check if user is not null
  useEffect(() => {
    if (user != null) {
      dispatch(getSession());
      return () => {};
    }
  }, [dispatch]);

  return (
    <ThemeProvider theme={theme}>
      <Wrapper>
        <Header />
        <Content>
          <Switch>
            <PrivateRoute exact path="/">
              <Home />
            </PrivateRoute>
            <PrivateRoute path="/dashboard">
              <Dashboard />
            </PrivateRoute>
            <PrivateRoute path="/feedback">
              <Feedback />
            </PrivateRoute>
            <PrivateRoute path="/request">
              <Request />
            </PrivateRoute>
            <PrivateRoute path="/release-notes">
              <ReleaseNotes />
            </PrivateRoute>
            <PrivateRoute path="/announcements">
              <Announcements />
            </PrivateRoute>
            <Route path="/login">
              <Login />
            </Route>
            <Route path="/login/r/:redirectUrl">
              <Login />
            </Route>
            <PrivateRoute>
              <NotFound />
            </PrivateRoute>
          </Switch>
        </Content>
        <Modals />
        <Footer />
      </Wrapper>
    </ThemeProvider>
  );
};
